import request from '@/utils/request';

// 十连抽
export function get_goods_column_lists(data) {
    return request({
        url: '/wap/integral/get_goods_column_lists',
        method: 'post',
        data: data,
        headers: {
            needToken: true
        }
    });
}
// 获取商品列表
export function get_goods_lists(data) {
    return request({
        url: '/wap/integral/get_goods_lists',
        method: 'post',
        data: data,
        headers: {
            needToken: true
        }
    });
}
// 获取会员积分
export function get_member_score(data) {
    return request({
        url: '/wap/integral/get_member_score',
        method: 'post',
        data: data,
        headers: {
            needToken: true
        }
    });
}
// 获取商品详情
export function get_goods_details(data) {
    return request({
        url: '/wap/integral/get_goods_details',
        method: 'post',
        data: data,
        headers: {
            needToken: true
        }
    });
}
// 兑换商品
export function exchange_goods(data) {
    return request({
        url: '/wap/integral/exchange_goods',
        method: 'post',
        data: data,
        headers: {
            needToken: true
        }
    });
} 